export enum Roles {
  ADMINISTRATOR = 'Administrator',
  RELAXMANAGER = 'RelaxManager',
  MANAGER = 'Manager',
  EDITOR = 'Editor',
  STANDARD = 'Standard',
  MEDIA = 'Media',
  CONTENT = 'content'
}
